import React, {useEffect, useState} from 'react';
import {
  Flex,
  Box,
  FormLabel,
  Spacer,
  Text,
  Modal,
  ModalFooter,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  useDisclosure,
  Heading,
  Textarea,
  Button,
} from '@chakra-ui/react';
import {CustomInput, SubmitButton, CustomButton} from '../../../General/FormInputs';
import {useForm, useFieldArray} from 'react-hook-form';
import FlexCard from '../../../General/FlexCard';

import {get, post, postDelete} from '../../../../service/ApiService';
import {Employee, Region} from '../../../../service/Urls';
import ErrorHelper from '../../../../service/ErrorHelper';
import {useClientOpp} from '../../../../views/Maintenance/OppPlanMaintenance';
import BoxCard from '../../../General/BoxCard';
import {formatDateForPicker} from '../../../../helpers/Functions';
import {ArrangerSelect} from '../../../Arranger/ArrangerSelect';
import OppPlanType from './OppPlanType';
import OppManager from './OppManager';
import OppIndividual from './OppIndividual';
import EmployeeInfo from './EmployeeInfo';
import AddBonus from './AddBonus';
import {isAdmin} from '../../../../helpers/localStorage';
import {useQueryClient} from 'react-query';
import EmployeeSelect from '../../../Employee/EmployeeSelect';
import AddOppEmployee from './AddOppEmployee';

export const emptyEmployee = {
  clientOId: '',
  emClient: 0,
  emCode: 0,
  emName: '',
  emDept: 0,
  emMgr: true,
  emArbal: 0,
  emMarbal: 0,
  emElookup: '',
  emTitle: '',
  emTarget: 0,
  emDefault: true,
  emDept: 1001,
  emInact: true,
  emDisc: 0,
  emEo: 0,
  emOppname: '',
  emMaxbon: 0,
  emSalary: 0,
  emMeo: 0,
  emPthres: 0,
  emPshare: 0,
  emMtarget: 0,
  emFloc: true,
  emCloc: false,
  emCeloc: false,
  emMloc: false,
  emPloc: false,
  emPetloc: false,
  emEloc: false,
  emMmaxbon: 0,
  emAdate: new Date().toISOString().split('T')[0],
  emTdate: null,
  emCremar: 0,
  emCremeo: 0,
  emCremarm: 0,
  emCremeom: 0,
  emArevfi: 0,
  emArevfm: 0,
  emArevci: 0,
  emArevcm: 0,
  emGroup: '',
  emAlias1: '',
  emAlias2: '',
  emAlias3: '',
  emRrate: 0,
  emRrrev: true,
  emRrtot: true,
  emComment: '',
};

const OppEmployee = props => {
  const {client} = useClientOpp();
  // this one is for after we search, set it with the limited data then onChange (aka useEffect) we will do the big employee query
  const [employeeRecord, setEmployeeRecord] = useState(null);
  const [employee, setEmployee] = useState(null);
  const [bonuses, setBonuses] = useState(null);
  const [regions, setRegions] = useState([]);
  const [options, setOptions] = useState([]);
  const [toast, setToast] = useState('');
  const [isUpdate, setUpdate] = useState(false);
  const [isSalesMan, setIsSalesMan] = useState(true);

  const queryClient = useQueryClient();

  const {
    register,
    handleSubmit,
    reset,
    control,
    getValues,
    setValue,
    formState: {errors},
  } = useForm();

  const {fields, append} = useFieldArray({
    control,
    name: 'test',
  });

  const {
    register: registerBonus,
    handleSubmit: handleBonusSubmit,
    reset: resetBonus,
    control: controlBonus,
    formState: {errors: bonusErrors},
  } = useForm();

  const {
    register: registerArranger,
    handleSubmit: handleArrangerSubmit,
    control: controlArranger,
    formState: {errors: arrangerErrors},
  } = useForm();

  // these are to control all the modals
  const {isOpen: isAddOpen, onOpen: onAddOpen, onClose: onAddClose} = useDisclosure();
  const {isOpen: isBonusOpen, onOpen: onBonusOpen, onClose: onBonusClose} = useDisclosure();
  const {isOpen: isArrangerOpen, onOpen: onArrangerOpen, onClose: onArrangerClose} = useDisclosure();
  const {isOpen: isSearchOpen, onOpen: onSearchOpen, onClose: onSearchClose} = useDisclosure();

  useEffect(async () => {
    if (isAdmin()) setIsSalesMan(false);
    const response = await get(Region.LIST + '?PageSize=' + 10000);
    const reg = [];
    response.data.forEach(re => {
      reg.push({label: re.rgId + ' - ' + re.rgDesc, value: re.id});
    });
    setRegions(response.data);
    setOptions(reg);
  }, []);

  useEffect(async () => {
    if (employeeRecord) {
      const data = await get('/Employee/' + employeeRecord);
      if (!data.errors) {
        setEmployee(data);
      }
    }
  }, [employeeRecord]);

  useEffect(async () => {
    if (employee) {
      setUpdate(true);

      employee.emAdate = employee.emAdate
        ? formatDateForPicker(employee.emAdate)
        : (employee.emAdate = employee.emAdate ?? new Date().toISOString().split('T')[0]);
      employee.emTdate = employee.emTdate ? formatDateForPicker(employee.emTdate) : null;

      if (client?.client?.clRep) {
        employee.clRep = client.client.clRep;
      }

      // reset();
      reset(employee);

      const bonus = await get(`/Employee/${employee.id}/bonuses`);
      if (!bonus.error) {
        setBonuses(bonus.data);
      } else {
        setBonuses([]);
      }
      // Adding - clear the records.  Couldn't find a cleaner way to do this
    } else {
      setUpdate(false);
      setEmployeeRecord(null);
      reset(emptyEmployee);
    }
  }, [employee]);

  useEffect(async () => {
    if (bonuses) {
      resetBonus({bonuses: bonuses});
    }
  }, [bonuses]);

  const onSubmit = async data => {
    if (!client.client) {
      setToast({response: {error: 'yep'}, errorMessage: 'First select a client to assign this employee to'});
      return;
    }

    let route = Employee.ADD;
    let message = 'added';
    // const deptId = await get('/Department/list?DpCode=' + data.emDept);
    // data.emDept = deptId?.data[0]?.id;
    data.emDept = parseInt(data.emDept);
    if (!data?.emTdate || data.emTdate === '') {
      data.emTdate = null;
    }

    if (isUpdate) {
      route = Employee.UPDATE + '/' + employee?.id;
      message = 'updated';
    } else {
      data.clientOId = client.opp.id;
    }
    const retVal = await post(route, data);
    setToast({response: retVal, successMessage: `Successfully ${message} employee`, errorMessage: `Error: Employee couldn't be ${message}`});
  };

  const saveBonus = async ({bonuses}) => {
    const formattedBonuses = bonuses.map(bonus => ({...bonus, id: bonus.id === '0' ? null : bonus.id}));
    let llContinue = true;
    let responseMessage = '';

    const retVal = await post(`/Employee/${employee?.id}/bonuses/update`, formattedBonuses);

    if (retVal.error) {
      llContinue = false;
      const error = retVal.errorMessage ?? retVal.error;
      responseMessage = error + ' \n ' + responseMessage;
    }

    if (llContinue) {
      setToast({response: {}, successMessage: 'Successfully saved bonuses'});

      queryClient.invalidateQueries('client');
    } else {
      setToast({response: {error: 'yep'}, errorMessage: responseMessage});
    }
    onBonusClose();
  };

  const addFD = async () => {
    const vals = getValues();
    if (vals?.arrId) {
      const retVal = await post(Employee.ADD_FD + '/' + vals.arrId, {arrangerId: vals.arrId});
      setToast({response: retVal, successMessage: 'Successfully added Funeral Director'});
    } else {
      setToast({response: {error: 'yep'}, errorMessage: 'Select an arranger to copy'});
    }
  };

  const cloneDept = async () => {
    const vals = getValues();
    if (vals?.clientOId && vals?.emDept) {
      const retVal = await post(`${Employee.DEPT_CLONE}/${employee.id}?ClientOId=${vals.clientOId}&Department=${vals.emDept}`, {});
      setToast({response: retVal, successMessage: 'Successfully cloned department'});
    } else {
      setToast({response: {error: 'yep'}, errorMessage: 'Error: Make sure both an employee and department are selected'});
    }
  };

  const deleteEmployee = async () => {
    if (!employee?.id) {
      setToast({response: {error: 'yep'}, errorMessage: 'No employee selected to delete'});
      return;
    }

    if (confirm(`Are you sure you want to remove ${employee?.emName?.trim()}?`)) {
      const retVal = await postDelete(Employee.DELETE + '/' + employee.id, {});
      setToast({response: retVal, successMessage: 'Successfully deleted employee'});
      setEmployee(null);
      reset(emptyEmployee);
    }
  };

  return (
    <Box>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FlexCard alignItems="flex-end" w={{base: '100%', xl: '85%'}}>
          <EmployeeSelect oppId={client?.opp?.id} setEmployeeId={setEmployeeRecord} />

          {isAdmin && (
            <>
              <Button
                colorScheme="secondary"
                w="100px"
                ml="2"
                onClick={() => {
                  onAddOpen();
                }}
              >
                Add
              </Button>
              <Button colorScheme="secondary" w="100px" ml="2" onClick={onArrangerOpen} type="button">
                Add FD
              </Button>
              <Button colorScheme="secondary" w="100px" ml="2" onClick={cloneDept} type="button">
                Dept Clone
              </Button>
              <Spacer />
              <Button colorScheme="secondary" w="100px" onClick={onBonusOpen}>
                Add Bonus
              </Button>
            </>
          )}
        </FlexCard>

        <Flex w={{base: '100%', xl: '85%'}}>
          <EmployeeInfo register={register} errors={errors} control={control} />
        </Flex>

        <Flex w={{base: '100%', xl: '85%'}}>
          <OppIndividual register={register} errors={errors} />
          <OppManager register={register} errors={errors} />
          <OppPlanType control={control} />
        </Flex>

        <BoxCard w={{base: '100%', xl: '85%'}}>
          <Flex justify={'left'}>
            <CustomInput
              register={register}
              id="emAlias1"
              name="Alias 1"
              errors={errors} // isReadOnly={employee ? false : true}
            />

            <CustomInput
              register={register}
              id="emAlias2"
              name="Alias 2"
              errors={errors}
              // isReadOnly={employee ? false : true}
            />

            <CustomInput
              register={register}
              id="emAlias3"
              name="Alias 3"
              errors={errors}
              // isReadOnly={employee ? false : true}
            />
          </Flex>
          <FormLabel htmlFor="clComment" mb="-0.5" ml="1" fontSize="sm">
            Comments
          </FormLabel>
          <Textarea
            placeholder="Comment"
            id="emComment"
            {...register('emComment')}
            // isReadOnly={employee ? false : true}
          />

          <Flex justify="space-between" mt={4}>
            <Button colorScheme="secondary" w="100px" type="submit" disabled={!employee}>
              Save
            </Button>
            <Button colorScheme="red" w="100px" mx="2" onClick={deleteEmployee} type="button" disabled={!employee}>
              Delete
            </Button>
          </Flex>
        </BoxCard>

        {/** ADD FD POPUP */}
        <Modal blockScrollOnMount={false} size={'4xl'} isOpen={isArrangerOpen} onClose={onArrangerClose}>
          <ModalOverlay />

          <ModalContent>
            <ModalHeader>
              <Heading>Add Funeral Director</Heading>
              <Spacer /> {employee?.name ? employee.name : ''}
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <ArrangerSelect register={register} errors={errors} id="arrId" required setRHFValue={setValue} clientId={client?.client?.id} />
            </ModalBody>

            <ModalFooter>
              <CustomButton name="Close Without Saving" mr={3} onClick={onArrangerClose} w="50%" />

              <Button
                w="50%"
                name="Add Funeral Director"
                mr={3}
                colorScheme="secondary"
                onClick={() => {
                  addFD();
                  onArrangerClose();
                }}
              >
                Add Funeral Director
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </form>

      <AddOppEmployee isOpen={isAddOpen} onClose={onAddClose} setToast={setToast} />

      {/** ADDITIONAL BONUS POPUP */}
      <Modal blockScrollOnMount={false} margin={3} isOpen={isBonusOpen} onClose={onBonusClose}>
        <ModalOverlay />
        <form onSubmit={handleBonusSubmit(saveBonus)}>
          <ModalContent maxW="85%">
            <ModalHeader>
              <Heading>Additional Bonuses</Heading>
              <Spacer /> {employee?.name ? employee.name : ''}
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              {employee?.id ? (
                <AddBonus control={controlBonus} register={registerBonus} errors={bonusErrors} bonuses={bonuses} />
              ) : (
                <Text>Please select an employee first</Text>
              )}
            </ModalBody>

            <ModalFooter justifyContent="flex-end">
              <CustomButton name="Close" colorScheme="blackAlpha" mr={3} onClick={onBonusClose} />
              {employee?.id && <SubmitButton name="Save" mr={3} />}
            </ModalFooter>
          </ModalContent>
        </form>
      </Modal>

      <ErrorHelper toastResponse={toast} />
    </Box>
  );
};

export default OppEmployee;
